import { useEffect, useState } from "react";

import { useAuth } from "../context/AuthContext";

import { getUserOrders } from "../services/orderService";

export default function Orders() {
  const { user } = useAuth();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const data = await getUserOrders();

    const myOrders = data.filter((o) => o.userId === user.id);

    setOrders(myOrders);
  };

  return (
    <div className="page">
      <h2>My Orders</h2>

      {orders.map((order) => (
        <div key={order.id} className="card">
          <p>Order: #{order.id}</p>

          <p>Total: ${order.total}</p>

          <p>
            Items:
            {order.items.length}
          </p>

          <p>{order.address}</p>
        </div>
      ))}
    </div>
  );
}
